<template>
  <div>
    <div class="d-flex justify-center">
      <v-slide-group
        show-arrows
        mandatory
        active-class="boton-color-talana"
        v-model="selected"
        class="mb-3"
      >
        <v-slide-item
          v-for="n in templatesOptions"
          :key="n.value"
          v-slot="{ active, toggle }"
        >
          <v-tooltip
            max-width="200"
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="mx-2 letter-spacing-0"
                :input-value="active"
                active-class="boton-color-talana white--text"
                depressed
                rounded
                @click="toggle"
              >
                {{ n.value }}
              </v-btn>
            </template>
            <span>{{ tabTooltip[n.value] }}</span>
          </v-tooltip>
        </v-slide-item>
      </v-slide-group>
    </div>

    <ks-assignment-template
      v-if="selected === 0 && ksTemplates"
      :ks-templates="ksTemplates"
      :category="1"
      :company="company"
      @update="getTemplates"
    />
    <ks-pending-template
      v-if="selected === 1 && ksTemplates"
      :ks-templates="ksTemplates"
      :category="2"
      :company="company"
      @update="getTemplates"
    />
    <ks-expiration-template
      v-if="selected === 2 && ksTemplates"
      :ks-templates="ksTemplates"
      :category="3"
      :company="company"
      @update="getTemplates"
    />
    <ks-answered-template
      v-if="selected === 3 && ksTemplates"
      :ks-templates="ksTemplates"
      :category="4"
      :company="company"
      @update="getTemplates"
    />
  </div>
</template>

<script>
import KsAssignmentTemplate from './components/ks-assignment-template.vue';
import KsExpirationTemplate from './components/ks-expiration-template.vue';
import KsPendingTemplate from './components/ks-pending-template.vue';
import KsAnsweredTemplate from './components/ks-answered-template.vue';
import { getKsEmailTemplates } from '../../../../api/keyscoring/email-templates';

export default {
  components: {
    KsAssignmentTemplate,
    KsExpirationTemplate,
    KsPendingTemplate,
    KsAnsweredTemplate,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      templatesOptions: [
        { value: 'Asignación' },
        { value: 'Recordatorio' },
        { value: 'Expiración' },
        { value: 'Rendido' },
      ],
      selected: null,
      ksTemplates: null,
      tabTooltip: {
        'Asignación': `Se enviará a tus postulantes para informarles que tienen una nueva
          solicitud por realizar dentro de tu proceso`,
        'Recordatorio': `Funciona a modo de recordatorio, para postulantes que tengan una solicitud
          pendiente aún no realizada.`,
        'Expiración': `Transcurridos los días de vigencia que elegiste, este correo informa que la
          solicitud pendiente ya no puede ser realizada.`,
        'Rendido': 'Tras la realización de la solucitud, el postulante será informado que la recibiste.',
      },
    };
  },
  methods: {
    getTemplates() {
      getKsEmailTemplates()
        .then((res) => {
          this.ksTemplates = res.emailTemplates;
        });
    },
  },
  beforeMount() {
    this.getTemplates();
  },
};
</script>

<style>

</style>
